import { render, staticRenderFns } from "./SelectLocale.vue?vue&type=template&id=e216d128&scoped=true&"
import script from "./SelectLocale.vue?vue&type=script&lang=ts&"
export * from "./SelectLocale.vue?vue&type=script&lang=ts&"
import style0 from "./SelectLocale.vue?vue&type=style&index=0&id=e216d128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e216d128",
  null
  
)

export default component.exports